interface ServerPathsInfo {
    Method: "POST" | "GET" | "PUT" | "DELETE",
    Path: string;
}

type PathKeys = "GetAccessToken" |
    "GemExecuteSQL" |
    "GemExecuteInfluxQL" |
    "GemExecuteInfluxFlux" |
    "GemGetHistory" |
    "GetPublicBoard" |
    "UserInfo" |
    "SetYodiBoardsSharedList" |
    "GetYodiBoardsSharedList" |
    "SaveYodiBoardMacros" |
    "UpdateYodiBoardConf" |
    "GetYodiBoards" |
    "LoadYodiBoards" |
    "UpdatePages" |
    "LoadDeletedYodiPages" |
    "DeleteYodiBoard" |
    "AddYodiBoard" |
    "GetYodiBoardVersions" |
    "ImportYodiBoard" |
    "SaveYodiBoardTheme" |
    "SaveUserSettings";

// ------------------------------------------------------------------------------------------------------------------
// Old working paths
var ServerPathsOld: Record<PathKeys, ServerPathsInfo> = {
    "GemExecuteSQL": {
        Method: "POST",
        Path: "/WebLib/Macros/ExecuteSQL"
    },

    "GemExecuteInfluxQL": {
        Method: "POST",
        Path: "/WebLib/Macros/ExecuteInflux/InfluxQL"
    },

    "GemExecuteInfluxFlux": {
        Method: "POST",
        Path: "/WebLib/Macros/ExecuteInflux/Flux"
    },

    "GemGetHistory": {
        Method: "POST",
        Path: "/WebLib/Dashboards/GetMacroHistory"
    },

    "GetAccessToken": {
        Method: "POST",
        Path: "/Token/GetAccessToken"
    },

    "GetPublicBoard": {
        Method: "POST",
        Path: "/WebLib/Dashboards/GetPublicYodiBoard"
    },

    "UserInfo": {
        Method: "POST",
        Path: "/UserInfo"
    },

    "SetYodiBoardsSharedList": {
        Method: "POST",
        Path: "/WebLib/Dashboards/SetYodiBoardsSharedList"
    },

    "GetYodiBoardsSharedList": {
        Method: "POST",
        Path: "/WebLib/Dashboards/GetYodiBoardsSharedList"
    },

    "SaveYodiBoardMacros": {
        Method: "POST",
        Path: "/WebLib/Dashboards/SaveYodiBoardMacros"
    },

    "UpdateYodiBoardConf": {
        Method: "POST",
        Path: "/WebLib/Dashboards/UpdateYodiBoardConf"
    },

    "GetYodiBoards": {
        Method: "POST",
        Path: "/WebLib/Dashboards/GetYodiBoards"
    },

    "LoadYodiBoards": {
        Method: "GET",
        Path: "/WebLib/Dashboards/LoadYodiBoards"
    },

    "UpdatePages": {
        Method: "POST",
        Path: "/WebLib/Dashboards/UpdatePages"
    },

    "LoadDeletedYodiPages": {
        Method: "POST",
        Path: "/WebLib/Dashboards/LoadDeletedYodiPages"
    },

    "DeleteYodiBoard": {
        Method: "POST",
        Path: "/WebLib/Dashboards/DeleteYodiBoard/"
    },

    "AddYodiBoard": {
        Method: "POST",
        Path: "/WebLib/Dashboards/AddYodiBoard"
    },

    "GetYodiBoardVersions": {
        Method: "POST",
        Path: "/WebLib/Dashboards/GetYodiBoardVersions"
    },

    "ImportYodiBoard": {
        Method: "POST",
        Path: "/WebLib/Dashboards/ImportYodiBoard"
    },

    "SaveYodiBoardTheme": {
        Method: "POST",
        Path: "/WebLib/Dashboards/SaveYodiBoardTheme"
    },

    "SaveUserSettings": {
        Method: "POST",
        Path: "/saveusersettings"
    }
}
// ------------------------------------------------------------------------------------------------------------------

// GLOW paths mapping
var ServerPathsGlow: Record<PathKeys, ServerPathsInfo> = {

    "GetAccessToken": {
        Method: "POST",
        Path: "/Emerald/Token/GetAccessToken"
    },

    "GemExecuteSQL": {
        Method: "POST",
        Path: "/Emerald.Gems/Sql/Execute"
    },

    "GemExecuteInfluxQL": {
        Method: "POST",
        Path: "/Emerald.Gems/InfluxQL/Execute"
    },

    "GemExecuteInfluxFlux": {
        Method: "POST",
        Path: "/Emerald.Gems/Flux/Execute"
    },

    "GemGetHistory": {
        Method: "GET",
        Path: "/Emerald.Boards/Gems/GetHistory"
    },

    "GetPublicBoard": {
        Method: "GET",
        Path: "/Emerald.Boards/Public/GetHistory"
    },

    "UserInfo": {
        Method: "GET",
        Path: "/Emerald/User/Info"
    },

    "SetYodiBoardsSharedList": {
        Method: "POST",
        Path: "/Emerald.Boards/SharedList/Update"
    },

    "GetYodiBoardsSharedList": {
        Method: "GET",
        Path: "/Emerald.Boards/SharedList/Get"
    },

    "SaveYodiBoardMacros": {
        Method: "POST",
        Path: "/Emerald.Boards/Gems/Update"
    },

    "UpdateYodiBoardConf": {
        Method: "POST",
        Path: "/Emerald.Boards/Board/UpdateConf"
    },

    "GetYodiBoards": {
        Method: "GET",
        Path: "/Emerald.Boards/Board/GetAll"
    },

    "LoadYodiBoards": {
        Method: "GET",
        Path: "/Emerald.Boards/Board/Get"
    },

    "UpdatePages": {
        Method: "POST",
        Path: "/Emerald.Boards/Pages/Update"
    },

    "LoadDeletedYodiPages": {
        Method: "GET",
        Path: "/Emerald.Boards/Pages/GetDeleted"
    },

    "DeleteYodiBoard": {
        Method: "DELETE",
        Path: "/Emerald.Boards/Board/Delete"
    },

    "AddYodiBoard": {
        Method: "PUT",
        Path: "/Emerald.Boards/Board/Add"
    },

    "GetYodiBoardVersions": {
        Method: "POST",
        Path: "/Emerald.Boards/Board/GetVersions"
    },

    "ImportYodiBoard": {
        Method: "PUT",
        Path: "/Emerald.Boards/Board/Import"
    },

    "SaveYodiBoardTheme": {
        Method: "POST",
        Path: "/Emerald.Boards/Themes/Update"
    },

    "SaveUserSettings": {
        Method: "POST",
        Path: "/Emerald/User/SaveSettings"
    }
}
// ------------------------------------------------------------------------------------------------------------------
export var ServerPaths: Record<PathKeys, ServerPathsInfo> = (process.env.GLOW_BUILD) ? ServerPathsGlow : ServerPathsOld;
export var EmeraldBaseUri = (process.env.GLOW_BUILD) ? "/Emerald/" : "/";
// ------------------------------------------------------------------------------------------------------------------